export default __webpack_public_path__ + "static/media/j7.929c3911.png";